import React from 'react';

const TIPS = [
  {
    title: 'Phone layout',
    body: 'On a phone the tools sit in a labelled bar at the bottom. Open one at a time — Layers, Tools, Draw, Find, Views, or More — so the 3D view is never covered by a pile of windows.',
  },
  {
    title: 'Layers panel',
    body: 'Press L to open Layers / Info / Stats. Dock it to the left or right so it sits beside the 3D view, or drag it to a screen edge. Browse, Visible, Cached, and Recent are packed together; Holes and BlockModels sit below as the two tools.',
  },
  {
    title: 'Inspect a block',
    body: 'Press I, then click a blast block (or a stope/drive if underground is enabled). The Info tab opens with attributes and production for that object. Triple-click a point in the scene to zoom to it.',
  },
  {
    title: 'Measure & hide',
    body: 'D measures distance (labels stay on the line). H hides the layer you click; U undoes. Iso in Layers can isolate several objects — click Iso again to remove one.',
  },
  {
    title: 'Your last view',
    body: 'Reload keeps camera, layers, opacity, grid, and panel layout in this browser. Use Views to bookmark a setup, or Share so others on this site can open it.',
  },
  {
    title: 'Look & background',
    body: 'Open Preferences for background colour and Studio lighting: Studio or Daylight for a realistic scene, Bright pop or Neon rim for a game-like view, High vis when you need every solid readable.',
  },
  {
    title: 'Find & fly',
    body: 'Press / to search a layer name and fly to it. G toggles the plan grid. S saves a high-resolution PNG.',
  },
  {
    title: 'Section',
    body: 'Press X for a slice through the mine. Click in the scene to place it, [ and ] to step, Look to view it face-on. Plot 2D draws holes on the plane with IDs and exports PDF. Esc exits the section.',
  },
  {
    title: 'Share a view',
    body: 'Views → Share copies a link (?view=). Anyone logged into this site opens the same camera, layers, and section. Copy ↗ on a view to send it again.',
  },
  {
    title: 'Offline',
    body: 'From the account menu, run Prepare Offline once while online, then Install the app for a desktop shortcut when DNS is down.',
  },
];

export default function OnboardingOverlay({ open, projectName, onClose, onOpenHelp }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[165] bg-black/75 flex items-center justify-center p-4 backdrop-blur-[2px]">
      <div
        role="dialog"
        aria-label="Welcome"
        className="w-full max-w-lg max-h-[min(92dvh,40rem)] overflow-y-auto rounded-md border border-yellow-600/40 bg-zinc-950 shadow-[0_20px_60px_rgba(0,0,0,0.6)] p-5"
      >
        <div className="mb-4">
          <p className="text-[9px] uppercase tracking-[0.16em] text-yellow-500/80">Welcome</p>
          <h3 className="text-base font-semibold text-yellow-400 tracking-wide mt-0.5">
            {projectName || 'MineDynamicsViewer'}
          </h3>
          <p className="text-[11px] text-zinc-400 mt-1 leading-relaxed">
            Quick tips to get started. Your last camera, layers, and panel layout restore automatically on reload.
          </p>
        </div>
        <ul className="space-y-3 mb-4 max-h-[min(50vh,22rem)] overflow-y-auto">
          {TIPS.map((tip) => (
            <li key={tip.title} className="rounded-sm border border-zinc-800/80 bg-black/40 px-3 py-2">
              <p className="text-[11px] font-semibold text-yellow-400/95">{tip.title}</p>
              <p className="text-[11px] text-zinc-400 mt-0.5 leading-relaxed">{tip.body}</p>
            </li>
          ))}
        </ul>
        <div className="flex flex-wrap items-center justify-end gap-2">
          <button
            type="button"
            className="m-0 h-8 px-3 text-[10px] uppercase tracking-wider text-zinc-400 border border-zinc-700 rounded hover:border-yellow-500/50 hover:text-yellow-400"
            onClick={onOpenHelp}
          >
            All shortcuts (?)
          </button>
          <button
            type="button"
            className="m-0 h-8 px-4 text-[10px] font-semibold uppercase tracking-wider bg-yellow-500 text-black rounded hover:bg-yellow-400"
            onClick={onClose}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
